module.exports = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4TEAAAAAvBoACEEcw//M//wbZRs7dERzCF+kDOcChgOEBiiFJkuO5B8AgDMYirM5A7BHR/0icQS3iDWqRv6kt3lSbO0kA"